<template>
  <div class="home">
<ElectronicaNavar/>
<ElectronicaBanner/>
<ElectronicaCategoria/>
<ElectronicaFqa/>
   <FooterSection/>
  </div>
</template>

<script>
import ElectronicaNavar from '@/components/Electronica/ElectronicaNavar.vue';
import ElectronicaBanner from '@/components/Electronica/ElectronicaBanner.vue';
import ElectronicaCategoria from '@/components/Electronica/ElectronicaCategoria.vue';
import ElectronicaFqa from '@/components/Electronica/ElectronicaFqa.vue';
import FooterSection from '@/components/FooterSection.vue';


export default {
  name: 'HomeView',
  components: {
    ElectronicaNavar,
    ElectronicaBanner,
    ElectronicaCategoria,
    ElectronicaFqa,
    FooterSection,
  }
}
</script>
